import { computed } from 'vue';

import store from '~store';

export default function isRechargeRequired(): boolean {
  const getters = store?.getters;
  const form = computed(() => getters.getCustomerForm);

  return form.value?.useRecharge === true;
}
